module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jcOEf"))).then(() => parcelRequire('9Lwss'));